import { apiSlice } from "../../app/apiSlice";
import configUrlOrgao from "../../config/urls/configUrlOrgao";
import { useOrgaoRoutes } from "../../config/useOrgaoRoutes";
import { Orgao } from "../../types/orgao/Orgao";




const endpointUrl = configUrlOrgao.ORGAO_API_EP


function createOrgao(obj: Orgao) {
    return {
        url: `${endpointUrl}/create`,
        method: "POST",
        body: obj,
    }
}

function updateOrgao(obj: Orgao) {
    return {
        url: `${endpointUrl}/${obj.id}`,
        method: "PUT",
        body: obj,
    }
}

function deleteOrgao({ id }: { id: string }) {
    return {
        url: `${endpointUrl}/${id}`,
        method: "DELETE",
    }
}
function getOrgaoes(search: string) {
    return {
        url: `${endpointUrl}/filter?search=${search}`,
        method: "GET",
    }
}




export const orgaoApiSlice = apiSlice.injectEndpoints({
    endpoints: ({ query, mutation }) => ({

        getOrgao: query<Orgao, string>({
            query: (id) => `${endpointUrl}/${id}`,
            providesTags: ["Orgao"],
            keepUnusedDataFor: 60, // mantém cache após desmontar por 60 secundos           
        }),

        getOrgaoes: query<Orgao[], string>({
            query: getOrgaoes,
            providesTags: ["Orgao"],
            
        }),




        createOrgao1: mutation<Orgao, Orgao>(
            {
                query: createOrgao,
                invalidatesTags: ["Orgao"]
            }),


        createOrgao: mutation<Orgao, Orgao>(
            {
                query: (obj) => ({
                    url: `${endpointUrl}/create`,  // Usando a variável endpointUrl diretamente
                    method: 'POST',    // Método POST para criar o orgao
                    body: obj,         // Corpo da requisição com os dados do novo orgao
                }),
                invalidatesTags: ["Orgao"]
            }),

        updateOrgao: mutation<Orgao, Orgao>({
            query: updateOrgao,
            invalidatesTags: ["Orgao"]
        }),

        deleteOrgao: mutation<Orgao, { id: string }>(
            {
                query: deleteOrgao,
                invalidatesTags: ["Orgao"],
            }),


    }),

});
export const {
    useGetOrgaoQuery,
    useGetOrgaoesQuery,
    useCreateOrgaoMutation,
    useUpdateOrgaoMutation,
    useDeleteOrgaoMutation,
    useCreateOrgao1Mutation,
} = orgaoApiSlice